import { http } from "../http";

export interface OwnTransfer {
    trnRequestType: string;
    PMTCUSTID: string;
    CUSTCIF: string;
    CUSTACC: string;
    AMOUNT: number;
    BENEFACC: string;
    PMTDET: string;
    COMMAMOUNT: number;
    BENEFACCTYPE: string;
    BENEFNAME: string;
    note: string;
};


export const newTransfer = async (transfer: OwnTransfer): Promise<OwnTransfer> => {
    const { data } = await http.post<OwnTransfer>("moneytransfer/owntransfer", transfer);
    return data;
};

